// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1TCxv","container":"styles_container__34Liq","title":"styles_title__3IBLd","wrapper":"styles_wrapper__1GWLY","answer":"styles_answer__c7pJ1"};